import { http } from '../utils/axios';
import { TPaginationResponse } from 'shared/types';
import { ILabPanel } from 'shared/interfaces/labPanel.interface';

class LabPanelsService {
  private static instance: LabPanelsService;

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  private constructor() {}

  static getInstance(): LabPanelsService {
    if (!LabPanelsService.instance) {
      LabPanelsService.instance = new LabPanelsService();
    }

    return LabPanelsService.instance;
  }

  getLabPanels = async (payload: { lab: string }) => {
    const { data } = await http<TPaginationResponse<ILabPanel[]>>({
      url: '/labPanels',
      method: 'GET',
      params: payload
    });

    return data;
  };
}

const instance = LabPanelsService.getInstance();

export default instance;
